jQuery(document).ready(function ($) {

  let check = jQuery('.mobile-filter--check-scroll');
  if (check.length > 0) {
    jQuery(window).scroll(function () {
      let checkOffset = check.offset().top;
      let curPos = jQuery(this).scrollTop();
      if (curPos >= checkOffset) {
        jQuery('section.filter .mobile-filter').addClass('sticky')
      } else {
        jQuery('section.filter .mobile-filter').removeClass('sticky')
      }
    })
  }
  $('section.filter .mobile-filter .filter-icon').click(function () {
    $('body').toggleClass('open-filter');
  })
  $('.close-mobile-filter , #FacetFiltersFormMobile .filter-heading.mobile svg').click(function () {
    $('body').removeClass('open-filter');
  })

  $('.sort-by-wrapper.mobile .dropdown-caret').click(function () {
    $(this).next().slideToggle();
  })

  var applyFilterTimeout;
  function setUpFilterPriceCheckboxesAndRadios() {
    $('.filter-price__list input[type="checkbox"], .filter-price__list input[type="radio"]').on('change', function () {
      let $this = $(this);

      countFilterItem();
   
      clearTimeout(applyFilterTimeout);
      if ($(window).width() > 777) {
          applyFilterTimeout = setTimeout(function () {
            $('.apply-filter button').trigger('click');
          }, 1000);
        }

      if ($this.is(':checked')) {
        $('.filter-price__list input[type="checkbox"]').not($this).prop('checked', false);
        let values = $this.val().split('-');
        $('.filter-price__dropdown input[name="filter.v.price.gte"]').val(values[0] || '');
        $('.filter-price__dropdown input[name="filter.v.price.lte"]').val(values[1] || '');
      }
    });
  }

  function setUpItemFilterClickEventsForCheckboxesAndRadios() {
    $('.item--filter').on('click', function () {
      let $input = $(this).find('input[type="checkbox"], input[type="radio"]');
      let text = $(this).find('span').text();

      countFilterItem();
      if ($input.is(':checked')) {
        clearTimeout(applyFilterTimeout);
        if ($(window).width() > 777) {
          applyFilterTimeout = setTimeout(function () {
            $('.apply-filter button').trigger('click');
          }, 1000);
        }
        
        createAndAppendFilterItem(text, $input.attr('id'));
      } else {
        removeFilterItemByTextAndInputId(text, $input.attr('id'));
      }
    });
  }


  function createAndAppendFilterItem(text, inputId) {
    var escapedInputId = inputId.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
    let $input = $('#' + escapedInputId);
    let inputName = $input.attr('name');
    let inputValue = $input.val();
    let isRadio = $input.attr('type') === 'radio';

    if (isRadio) {
      let $existingElement = $('.filterItemName .filterItemName-container .item-text[data-c-name="' + inputName + '"]');
      if ($existingElement.length > 0) {
        $existingElement.text(text).attr('data-input-id', inputId);
        return;
      }
    }

    if ($('.filterItemName .filterItemName-container .item-text[data-input-id="' + inputId + '"]').length === 0) {
      let $element = $('<div>').addClass('item-text').text(text).attr({
        'data-input-id': inputId,
        'data-c-name': inputName,
        'data-value': inputValue
      });
      $element.append('<span class="item-remove"></span>');
      $('.filterItemName .filterItemName-container').append($element);
      $element.find('.item-remove').on('click', function () {
        $input.prop('checked', false);
        $element.remove();
        clearTimeout(applyFilterTimeout);
        applyFilterTimeout = setTimeout(function () {
          console.log($('.apply-filter button'))
          $('.apply-filter button').trigger('click');
        }, 1000);
      });
    }
  }

  function removeFilterItemByTextAndInputId(text, inputId) {
    $('.filterItemName .filterItemName-container .item-text').each(function () {
      let $this = $(this);
      if ($this.text().trim().startsWith(text) && $this.data('inputId') == inputId) {
        $this.remove();
      }
    });
  }

  function displayCheckedItemsForCheckboxesAndRadios() {
    let checkedItems = $('.item--filter input[type="checkbox"]:checked, .item--filter input[type="radio"]:checked');
    let count = checkedItems.length;
    let nonSortByCheckedItems = checkedItems.filter(function () {
      return $(this).attr('name') !== 'sort_by';
    });

    nonSortByCheckedItems.each(function () {
      let text = $(this).closest('.item--filter').find('span').text();
      createAndAppendFilterItem(text, this.id);
    });

    if (nonSortByCheckedItems.length > 0) {
      $('.clear-all').removeClass('hide');
    }
  }

  function countFilterItem() {
    jQuery('#FacetFiltersFormMobile .filter-options .dm').each(function(){
      let label = $(this).find('.filter-count');
      let inputs = $(this).find('input:checked');
      if (inputs.length > 0) {
          label.text(`(${inputs.length})`)
      }
    })
  }
  
  setUpFilterPriceCheckboxesAndRadios();
  setUpItemFilterClickEventsForCheckboxesAndRadios();
  displayCheckedItemsForCheckboxesAndRadios();
  countFilterItem();

  if ($('#FacetFiltersFormMobile').length > 0) {
    $('#FacetFiltersFormMobile .dropdown-caret').click(function () {
      $(this).closest('.dm').toggleClass('active').siblings().removeClass('active').find('.filter-container').slideUp();
      $(this).next().slideToggle()
    })
    $(document).on('click', function (e) {
      if ($(e.target).closest('.closex').length <= 0) {
        $('.filter-container').slideUp();
        $('.dm.closex').removeClass('active');
      }
    })

    let sortbyOptions = $('#FacetFiltersFormMobile #sort_by').html();
    $('.sort-by-wrapper.mobile ul#sort_by').html(sortbyOptions);

    $('.sortByBlock li.sort-option').click(function () {
      let txt = $(this).text();
      let sortValue = $(this).data('value');
      $(this).attr('data-selected', true).siblings().attr('data-selected', false);
      $(this).closest('.sortByBlock').slideUp().prev().removeClass('active').find('.current').text(txt);

      updateSortByParam(sortValue);
    })
  }

  function updateSortByParam(sortValue) {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    if (params.has('sort_by')) {
      params.set('sort_by', sortValue);
    } else {
      params.append('sort_by', sortValue);
    }

    url.search = params.toString();
    window.history.replaceState({}, '', url);
    applyFilterTimeout = setTimeout(function () {
      window.location.reload();
    }, 200);
  }

  $('.slide-control .btn').click(function () {
    let activeImage = $(this).closest('.card-image').find('.product-image.active');
    $(this).closest('.card-image').find('.product-image:not(.active)').addClass('active');
    activeImage.removeClass('active');
  })
})